import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const MTN_API_BASE_URL = process.env.REACT_APP_MTN_API_BASE_URL || '';
// The tenant's publishable key in the engine. It is not a secret: it identifies this front.
const TENANT_KEY = process.env.REACT_APP_TENANT_KEY || '';

if (!TENANT_KEY) {
  console.error('REACT_APP_TENANT_KEY is not set: the engine will reject requests with 401.');
}

const createApiClient = (baseURL = API_BASE_URL || undefined, config = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...(config.headers || {})
  };

  return axios.create({
    ...config,
    baseURL,
    headers
  });
};

// Only the engine gets the key: mtnApi is a different API.
const engineApi = createApiClient(undefined, {
  headers: TENANT_KEY ? { 'X-Tenant-Key': TENANT_KEY } : {}
});
const mtnApi = createApiClient(MTN_API_BASE_URL);

export { engineApi, mtnApi };
